import { UserType } from '@types'
import { arrayToObject } from '@utils/functional'
import { createReducer } from '@reduxjs/toolkit'
import {
  createUserSuccess,
  deleteUser,
  saveUserSuccess,
  setUser,
  setUsers,
} from '@store/actions/users'

type State = Record<string, UserType>

const initialState = {} as State

const usersReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUser, (state, action) => {
      state[action.payload.id] = action.payload
    })
    .addCase(saveUserSuccess, (state, action) => {
      state[action.payload.id] = action.payload
    })
    .addCase(createUserSuccess, (state, action) => {
      state[action.payload.id] = action.payload
    })
    .addCase(setUsers, (state, action) => {
      const userObject = arrayToObject('id', action.payload)

      return { ...state, ...userObject }
    })
    .addCase(deleteUser, (state, action) => {
      delete state[action.payload.id]
    })
})

export default usersReducer
